/* eslint-disable no-shadow */
export enum AcceptanceMethodEnum {
  checkBox = "checkBox",
}

export enum LanguageEnum {
  es = "es",
}